import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  Label,
} from "reactstrap"

import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// import images
import profile from "assets/images/login_img2.png"
import logo from "assets/images/logo.svg"
import secureLocalStorage from "react-secure-storage"
import { app_url } from "app_config"
import { axiosbaseurl } from "configure"
import { socket } from "helpers/Connection"
import { usePermissionData } from "AppContext"

const Login = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [showPwd, setShowPwd] = useState(false)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const { setLoginStatus } = usePermissionData()

  document.title = "Login | Peacock Accountants Limited."

  useEffect(() => {
    if (secureLocalStorage.getItem("authUser") && secureLocalStorage.getItem("token")) {
      navigate(`${app_url}`)
    }
  })

  const handleLogin = async e => {
    e.preventDefault()
    try {
      if (email) {
        setLoading(true)
        const response = await axiosbaseurl.post("/auth/login", {
          email,
          password,
        })

        if (response.data.success) {
          if (
            response.data.message ===
            "New Weekly Password has been sent on your email."
          ) {
            setError(response.data.message)
          } else {
            secureLocalStorage.setItem("authUser", response.data.user)
            secureLocalStorage.setItem("token", response.data.token)
            socket.emit("register", response.data.user.employeeId)
            setLoginStatus(true)
            navigate(`${app_url}dashboard`)
          }
        }
      }
    } catch (error) {
      setError(
        error.response.data.message || error.message || "Something went wrong"
      )
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="account-pages pt-5 pb-4">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="shadow">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={8}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary fw-bold">Welcome Back !</h5>
                        <p>
                          Sign in to continue to <br />{" "}
                          <span className="fw-semibold">
                            Peacock Accountants Limited.
                          </span>{" "}
                        </p>
                      </div>
                    </Col>
                    <Col className="col-4 align-self-center pe-4">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2 mt-3">
                    <div>
                      {error && (
                        <div className="alert alert-danger">{error}</div>
                      )}
                    </div>
                    <Form className="form-horizontal" onSubmit={handleLogin}>
                      <div className="mb-3">
                        <Label className="form-label">
                          Email <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="email"
                          className="form-control form_field"
                          placeholder="Enter email"
                          type="email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">
                          Password{" "} <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="password"
                          className="form-control form_field"
                          type={showPwd ? "text" : "password"}
                          placeholder="Enter Password"
                          value={password}
                          onChange={e => setPassword(e.target.value.trimEnd())}
                          required
                        />
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="showpwd"
                          onChange={e => setShowPwd(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="showpwd">
                          Show Password
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <i className="bx bx-hourglass bx-spin align-middle me-2"></i>{" "}
                              Logging In
                            </>
                          ) : (
                            "Log In"
                          )}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                      <div className="mt-4 text-center">
                        <p className="px-md-4">
                          Copyright © {new Date().getFullYear()}{" "}
                          <a
                            href="https://www.peacockac.com/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Peacock Accountants Limited.
                          </a>{" "}
                          <br /> Crafted with{" "}
                          <i className="mdi mdi-heart text-danger" /> by{" "}
                          {
                            process.env.REACT_APP_API_URL?.includes("apibms.peacockac.com") ?
                              <a
                                href="https://www.tcwitservices.com"
                                target="_blank"
                                rel="noreferrer"
                                className="text-dark"
                              >
                                The Care Workshop
                              </a>
                              :
                              <a
                                href="https://zithas.co.uk/"
                                target="_blank"
                                rel="noreferrer"
                                className="text-dark"
                              >
                                Zithas Technologies
                              </a>
                          }
                        </p>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              {/* <div className="mt-5 text-center">
                <p>
                  Don&#39;t have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>

              </div> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
